<template>
    <section id="product__extended" class="product__extended" :class="[background, spaces]">
        <div class="c-container">
            <div class="product__extended__scene" ref="$scrollScene">
                <div class="line" v-for="element in scrolledContent" :key="element.id" data-scene-point>
                    <component :is="eComponents[element.typeHandle]" :data="element" />
                </div>
                <div class="line" data-scene-point>
                    <UiMarquee v-if="modelType" :text="modelType.alternative" />
                </div>
            </div>
        </div>
    </section>
</template>

<script setup>
    const props = defineProps({
        data: {
            type: Object,
            default: () => ({})
        },
        background: {
            type: String,
            default: ""
        },
        spaces: {
            type: String,
            default: "pst-50 psb-50"
        }
    });

    const scrolledVideo = resolveComponent("ProductScrolledVideo");
    const scrolledText = resolveComponent("ProductScrolledText");
    const $scrollScene = ref(null);
    const scrolledContent = computed(() => useCmsArray(props.data.scrolledContent));
    const modelType = computed(() => useCmsFirst(props.data.modelType));

    const eComponents = computed(() => ({
        scrolledVideo: scrolledVideo,
        scrolledText: scrolledText
    }));
</script>
